<p-sidebar [(visible)]="showaddUpdateModal" [position]="'right'" (onHide)="closeAllotmentDialogue()"
  [closeOnEscape]="false" [dismissible]="false" [style]="{width:'90rem'}">
  <ng-template pTemplate="header">
    <h3>Add Allotment</h3>
  </ng-template>
  <ng-template pTemplate="content">
    <app-allotment-addupdate [allotmentRelatedData]="allotmentSupportData"
      (changeModalStatus)="changeAddUpdateModelState($event)"></app-allotment-addupdate>
  </ng-template>
</p-sidebar>
<app-allotment-list [allotmentListData]="allotmentList"
  (changeAddUpdateAllotmentState)="changeAddUpdateModelState($event)"></app-allotment-list>